import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class OrderInformationModule extends VuexModule {
  items: any = [];
  isReUpdateOrder = false;

  @Mutation
  removeItemOrderInformation() {
    this.items = [];
  }

  @Mutation
  addItemToOrderInformation(orderInformation: any[]) {
    this.items = orderInformation
  }
  @Mutation
  replaceItemOrderInformation(data) {
    this.items = data;
  }

  @Mutation
  updateFlash(isUpdate: boolean) {
    this.isReUpdateOrder = isUpdate;
  }

  @Action({ rawError: true })
  async addOrderInformation(orderInformation: any[]) {
    this.context.commit("addItemToOrderInformation", orderInformation);
  }

  @Action({ rawError: true })
  async orderInformationRemove() {
    this.context.commit("removeItemOrderInformation");
  }

  @Action({ rawError: true })
  async replaceOrderInformation(data) {
    this.context.commit("replaceItemOrderInformation", data);
  }

  @Action({ rawError: true })
  async isUpdateFlash(isUpdate: boolean) {
    this.context.commit("updateFlash", isUpdate);
  }

  get totalItems() {
    return this.items.length;
  }

  get orderItems() {
    return this.items;
  }

  get getIsUpdateFlash() {
    return this.isReUpdateOrder;
  }
}
